import * as React from 'react';
import { observer } from 'mobx-react';
import { IClubTextValueLabelProps } from './IClubTextValueLabelProps';

@observer
export class ClubTextValueLabel extends React.Component<IClubTextValueLabelProps, undefined> {
  render() {
    const additionalProps = {} as any;
    this.props.textAnchor && (additionalProps.textAnchor = this.props.textAnchor);
    if (this.props.additionalInformationId) {
      additionalProps['data-target'] = this.props.additionalInformationId;
      additionalProps['data-toggle'] = 'modal';
    }
    const valueBottomShift = 25;
    const defaultValueType = 'deg';
    return (
      <g className={this.props.additionalInformationId ? 'pointer-cursor' : ''}>
        <text
          id="left-side-dynLoftText"
          className="attributeText"
          x={this.props.x}
          y={this.props.y}
          {...additionalProps}
        >
          {this.props.text}
        </text>
        <text>
          <tspan
            className="attributeValue"
            dx="0"
            dy="0"
            x={this.props.x}
            y={this.props.y + valueBottomShift}
            fill="#EC691A"
            {...additionalProps}
          >
            {this.props.value}
            <tspan className="attributeText" dx="5" dy="0" fill="#EC691A">
              {this.props.valueType || defaultValueType}
            </tspan>
          </tspan>
        </text>
      </g>
    );
  }
}
